import React, { useEffect, useState } from 'react';
import xtend from 'xtend';
import queryString from 'query-string'

import IoMdVideocam from 'react-icons/lib/io/ios-videocam'
import Modal from '../../../common/components/Modal';
import Assets from '../../../metadata/components/assets/Assets';
import AssetListing from '../../../metadata/components/assets/AssetsListing';
import EmbedAndShare from './tabs/EmbedAndShare';
import General from './tabs/General';
import Automation from './tabs/Automation';
import Categories from './tabs/EventCategories';
import Keywords from './tabs/EventKeywords';
import Technicians from './tabs/EventTechnicians';
import Locations from './tabs/EventLocations';
import EventTranscription from './tabs/EventTranscription';
import EventAudioDescription from './tabs/EventAudioDescription';
import Facebook from './tabs/Facebook';
import StreamTargets from './tabs/targets';
import RestrictedComponent from '../../../lib/components/form/RestrictedComponent';
import QueryString from '../../../utils/QueryString';
import history from '../../../history';
import Loader from '../../../common/components/notifications/Loader';

const Metadata = props => {
    const [miscAssignModal, setMiscAssignModal] = useState(false)
    useEffect(() => {
        const qsTab = QueryString.parse(location.search).tab
        if(qsTab !== activeTab && qsTab) {
            setActiveTab(qsTab)
        }
    }, [history.location.search])
    const activeTab = props.tab
    const setActiveTab = props.setTab

    /*
        Available Tabs: (Default to "assets")
            analytics
            assets
            automation
            categories
            facebook
            general
            keywords
            locations
            share
            stream-targets
            technicians
            transcript
    */
   
    const openTab = (target, event) => {
        if (event) event.preventDefault();
        
        const qs = queryString.parse(location.search)
        qs.tab = target
        history.push(`${window.location.pathname}?${queryString.stringify(qs)}`)
        setActiveTab(target)

        var emitterFn;
        try {
            emitterFn = props.actions[target].get;
        } catch (err) {
            return; // do nothing
        }

        if (!emitterFn) return;

        var payload = {};
        if (target != 'locations') {
            payload.eventID = props.event.eventID;
        }

        emitterFn(payload);
    }

    useEffect(() => {
        // do initial request for directly loaded tab
        const qsTab = queryString.parse(location.search).tab
        if (qsTab) {
            openTab(qsTab)
        }
    }, [])

    const toggleMiscAssignModal = () => {
        if (!miscAssignModal) {
            props.actions.assets.getMiscAssets({});
        }
        setMiscAssignModal(!miscAssignModal)
    }

    const assignToEvent = (asset) => {
        var payload = {
            eventID: props.event.eventID,
            assetID: asset.assetID
        };
        props.actions.miscAssetToEvent(payload);
        toggleMiscAssignModal();
    }

    const onKeywordsSave = (ev) => {
        props.actions.editKeywords(ev);
    }

    
    var eventResolving = props.requests.events.isResolving;

    var actions = {
        restrictedDomains: props.actions.restrictedDomains,
        edit: function (data) {
            props.actions.editEvent(xtend({
                eventID: props.event.eventID
            }, data));
        }
    };

    if (props.event === undefined) return <Loader/>
    var tab;
    switch (activeTab) {
        case 'stream-targets':
            tab = <StreamTargets {...props}/>
            break;

        case 'assets':
            tab = <Assets
                {...props}
                emitSnack={props.emitSnack}
                toggleMiscAssignModal={toggleMiscAssignModal}
                assets={props.event.mediaAssets}
                getMiscAssets={props.actions.assets.getMiscAssets}
                mode="event"
            />;
            break;

        /**
         * @fixme ??
         */
        // case 'analytics':
        //     tab = <Analytics {...props}
        //         ga={props.ga}
        //         eventID={props.event.get('eventID')}
        //         {...props.data.analytics}
        //     />;
        //     break;

        case 'general':
            tab = <General
                clientID={props.clientID}
                timeZone={props.timeZone}
                event={props.event}
                isResolving={eventResolving}
                actions={actions}
            />;
            break;
        case 'automation':
            tab = <Automation
                timeZone={props.timeZone}
                event={props.event}
                actions={actions}
            />;
            break;

        case 'categories':
            tab = <Categories
                {...props.data.categories}
                isResolving={eventResolving}
                event={props.event}
                actions={xtend(props.actions.categories, {
                    editEvent: actions.edit
                })}
            />;
            break;

        case 'keywords':
            tab = <Keywords
                {...props.data.keywords}
                event={props.event}
                isResolving={eventResolving}
                onSave={onKeywordsSave}
            />;
            break;

        case 'technicians':
            tab = <Technicians
                {...props}
                {...props.data.technicians}
                isResolving={eventResolving ||
                    props.requests.technicians.isResolving}
                actions={xtend(props.actions.technicians, {
                    editEvent: actions.edit
                })}
            />;
            break;

        case 'locations':
            tab = <Locations
                {...props}
                isResolving={eventResolving}
                {...props.data.locations}
                actions={xtend(props.actions.locations, {
                    editEvent: actions.edit
                })}
            />;
            break;
        case 'share':
            tab = <EmbedAndShare
                {...props}
            />;
            break;
        case 'facebook':
            tab = <Facebook
                {...props}
            />;
            break;
        case 'transcript':
            tab = <EventTranscription
                {...props}
            />;
            break;
        case 'audio-description':
            tab = <EventAudioDescription
                {...props}
            />;
            break;
    }

    const domains = {
        'assets': 'Assets',
        'share': 'Player',
        'general': 'General',
        'automation': 'Automation',
        'transcript': 'Transcription',
        'audio-description': 'Audio Description',
        'categories': 'Categories',
        'keywords': 'Keywords',
        'technicians': 'Technicians',
        'locations': 'Location',
        'stream-targets': <span>
            <IoMdVideocam/> Social Live
        </span>
    };
    const getTabPermission = tab => {
        let permission = 'event_tab_'
        switch (tab) {
            case 'share':
                return permission + 'player.read'
            case 'transcript':
                return permission + 'transcription.read'
            case 'locations':
                return permission + 'location.read'
            case 'stream-targets':
                return permission + 'social.read'
            case 'audio-description':
                return true
            default:
                return permission + tab + '.read'
        }
    }

    return (
        <div className="metadata" data-testid="event-metadata-container">
            <ul className="nav nav-tabs">
                {Object.keys(domains).map(function (domain, i) {
                    return (
                        <li
                            key={domain + '-' + i}
                            className={activeTab == domain ? 'active' : ''}
                        >
                            <RestrictedComponent
                                style={{
                                    display: 'block',
                                    padding: '10px 15px',
                                    backgroundColor:'#eee',
                                    borderRadius: '4px 4px 0 0',
                                    border: '1px solid transparent',
                                    marginRight: '2px'
                                }}
                                permissionCheck={getTabPermission(domain)}>
                                <a href="#" onClick={openTab.bind(null, domain)}>
                                    {domains[domain]}
                                </a>
                            </RestrictedComponent>
                        </li>
                    );
                }, this)}
            </ul>

            <div className="tab-content">
                <div role="tabpanel" className="tab-pane active clearfix">
                    {tab}
                </div>
            </div>

            {(miscAssignModal) ?
                <Modal modalType="assign-media" cancelModal={toggleMiscAssignModal}>
                    <Modal.Header>Assign Asset from Media Library</Modal.Header>
                    <Modal.Body>
                        <AssetListing
                            assignToEvent={assignToEvent}
                            actions={props.actions.assets}
                            isResolving={props.miscAssets.isResolving}
                            data={props.miscAssets.data}
                            mode="assign"
                        />
                    </Modal.Body>
                    <Modal.Footer></Modal.Footer>
                </Modal> :

                null
            }
        </div>
    );
}

export default Metadata;
